import React from 'react';
import AccountSettings from '../containers/AccountSettings';

const AccountSettingsPage: React.FC = () => {
  return <AccountSettings />;
};

export default AccountSettingsPage;
